import {newRequest} from '@/utils/request'

// 获取有权限的平台
export const getAppByAdmin = <T>(id: string) => newRequest.get<Ajax.Response<T>>(`/authority/platform/getAppByAdmin?adminId=${id}`)

// 查询平台列表
export const getAppList = <T>() => newRequest.get<Ajax.Response<T>>('/authority/platform/querylist')

// 新增
export const add = <T>(params: any) => newRequest.post<Ajax.Response<T>>('/authority/platform/add', params)

// 修改
export const update = <T>(params: any) => newRequest.post<Ajax.Response<T>>('/authority/platform/update', params)
